export default __webpack_public_path__ + "static/media/eng-icon.f5500fff.svg";